export default __webpack_public_path__ + "static/media/Menu_Polar_Vest.6988702a.svg";